const e = {
  open: !1,
  preventCloseOnOutsideClick: !1,
  maxHeight: "464px",
  maxWidth: "600px",
  closeable: !0,
  variant: "default",
  size: "medium"
};
export { e as modalDefaultProps };